// DEFAULT ROOT PATH
export const DEFAULT_PATH = '/'; 

// REST API URL (Collect Feedback)
export const COLLECT_FEEDBACK_API = "https://m6bduqqo8h.execute-api.ap-southeast-1.amazonaws.com/prod/messages"

// Login API URL
export const LOGIN_API = "https://auth.api.celcomdigi.tech/login/profile"
